import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/setSeconds/index.js';

var require$$28 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$28 as default };
